"use client"

import { NestedNavigationLinksType } from "common/SiteLinks"
import { createContext, ReactNode, useContext } from "react"

/**
 * Exposes the CMS-mapped header nav links (see `mapMenuToNavLinks`) to pages
 * that mount their own <Header> outside the shared Layout header — e.g. the
 * car-model page. Layout hides its header on those routes, so without this the
 * model-page drawer received no `links` and rendered an empty, collapsed menu
 * (DLK-845). Provided by Layout, which already holds the menu data.
 */
const NavLinksContext = createContext<NestedNavigationLinksType[] | undefined>(
  undefined
)

export const NavLinksProvider = ({
  navLinks,
  children,
}: {
  navLinks: NestedNavigationLinksType[] | undefined
  children: ReactNode
}) => (
  <NavLinksContext.Provider value={navLinks}>
    {children}
  </NavLinksContext.Provider>
)

export const useNavLinks = () => useContext(NavLinksContext)
